const state = () => ({
  basicPage: null,
  content: null,
  filters: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, `${this.$config.env.apiURL}${url}`);
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
